import { conditionalBranchMessage } from '../functions'

export default {
  function: {
    upload_common: {
      conditional_branch_message: (args: any) =>
        conditionalBranchMessage(args, (triggerQuestionSelectMetaList) => {
          if (triggerQuestionSelectMetaList.length === 1) {
            const { categoryName, questionDisplayNumber, selectText } = triggerQuestionSelectMetaList[0]
            return `Dành cho những ai trả lời '${selectText}' ở Số ${questionDisplayNumber} của ${categoryName} (Câu hỏi bắt buộc)`
          }

          const messages = triggerQuestionSelectMetaList.map(
            ({ categoryName, questionDisplayNumber, selectText }) => {
              return `'${selectText}' ở Số ${questionDisplayNumber} của ${categoryName}`
            }
          )
          return `Dành cho những ai trả lời ${messages.join(' hoặc ')}. (Câu hỏi bắt buộc)`
        }),
    },
    validation: {
      decimal_max_digit: 'Nhập vào tới {decimalMaxDigit} chữ số thập phân',
    },
  }
}
